module.exports = __webpack_public_path__ + "img/image-404.2c6f7f1b.svg";